import Divider from 'components/ui/Divider';
import GeneralInformation from 'components/ui/GeneralInformation';
import { Rating } from 'components/ui/Rating';
import SecurityAnalysis from 'components/ui/SecurityAnalysis';
import TruckInformation from 'components/ui/TruckInformation';
import useBlockedProfileEvents from 'hooks/events/useBlockedProfileEvents';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import React from 'react';
import * as Styled from './styled';

const mockData: ITruckerProfileProps = {
  trucker: {
    id: 'xxxxxxx',
    uuid: 'xxxxxxx',
    inContactList: false,
    isVip: false,
    name: 'xxxxxxx xxxxxxx',
    phones: [{ ddd: 99, hasWhatsapp: true, number: 999999999 }],
    mainProducts: ['xxxxxxx'],
    address: {
      city: 'xxxxxxx',
      complement: 'xxxxxxx',
      district: 'xxxxxxx',
      state: 'xx',
      street: 'xxxxxxx',
      zipCode: 'xxxxxxx',
      number: 'xxxx',
    },
    bank: {
      name: 'xxxxxxx',
      number: 'xxxxxxx',
      pix: [{ key: 'xxxxxxx', type: 'phoneNumber', status: 'active' }],
      account: {
        branchNumber: 'xxxxxxx',
        document: 'xxxxxxx',
        number: 'xxxxxxx',
        type: 'xxxxxxx',
        createdAt: '',
      },
    },
    cnh: {
      category: 'xx',
      expirationDate: 'xx/xxxx',
      name: 'xxxxxxx',
      timeSinceFirstLicense: 'xxxxx',
    },
    lastLocation: {
      city: 'xxxxxxx',
      distance: 0,
      hasDistance: true,
      state: 'xx',
      timeSinceCollected: null,
      isApproximated: true,
    },
    mainDestination: {
      city: 'xxxxxxx',
      state: 'xx',
    },
    timeSinceCreated: 'xxxxxxx',
    vehicles: [
      {
        id: 'xxxxxxx',
        rntrc: 'xxxxxxx',
        tracker: 'xxxxxxx',
        locator: 'xxxxxxx',
        images: ['xxxxxxx'],
        tractor: {
          plate: 'xxxxxxx',
          type: 'xxxxxxx',
        },
        body: [
          {
            name: 'xxxxxxxxx',
            plate: 'xxxxxxxxx',
          },
          {
            name: 'xxxxxxx',
            plate: 'xxxxxxx',
          },
        ],
      },
    ],
    availability: {
      destination: 'xxxx',
      isAvailable: true,
      originLocation: 'xxxx xx xxxx',
      originUF: 'xx',
      locationType: 'city',
    },
  },
  evaluation: {
    attributes: ['xxxxxxxxxx', 'xxxxxxxxx', 'xxxxxxxx', 'xxxxxxx'],
    grade: 0.1,
    total: 99,
  },
  journey: {
    total: 0,
  },
  isVerified: false,
  isBlocked: true,
  securityAnalysis: {
    documents: [
      {
        description: 'CNH',
        status: 'NÃO INFORMADO',
      },
      {
        description: 'ENDEREÇO',
        status: 'NÃO INFORMADO',
      },
      {
        description: 'CPF',
        status: 'NÃO INFORMADO',
      },
      {
        description: 'SELFIE',
        status: 'NÃO INFORMADO',
      },
    ],
  },
};

const BluredArea = () => {
  const { requestAccessOnBlurEvent } = useBlockedProfileEvents();

  const handleBlurEvent = () => {
    requestAccessOnBlurEvent();
  };

  return (
    <Styled.ClickableArea onClick={() => handleBlurEvent()} data-testid="blured-container">
      <Styled.ContentWrapper>
        <Divider />
        <GeneralInformation data={mockData} isOpenSearch={false} />
        <Divider />
        <TruckInformation data={mockData} />
        <SecurityAnalysis data={mockData} />
        <Rating {...mockData.evaluation} />
      </Styled.ContentWrapper>
    </Styled.ClickableArea>
  );
};

export default BluredArea;
